// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"8db78d0d","488":"a924547c"}[chunkId] + ".chunk.js";
};